/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";
import { Button, Input } from "../../atoms";
import { useFirestoreCollection } from "../../../hooks/useFirestoreCollection";
import { fetchBookingsFromFirestore } from "../../../firestore/firestoreService";
import {
  listenToPrivateYachtBookingFilter,
  listenToPrivateYachtBookings,
} from "../../../redux/data/booking/bookingActions";
import { PageToolbar } from "../../molecules";
import { bookingTypes } from "../../../enums";

interface IPrivateYachtBookingListToolbarProps {
  searchBookingId: string;
  onSearchBookingIdChange: (value: string) => void;
}

export const PrivateYachtBookingListToolbar: React.FC<
  IPrivateYachtBookingListToolbarProps
> = ({ searchBookingId, onSearchBookingIdChange }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const { width } = useWindowSize();
  const { privateYachtBookingTotal } = useSelector(
    (state: any) => state.bookings
  );
  useFirestoreCollection({
    query: () =>
      fetchBookingsFromFirestore([
        {
          type: "filter",
          name: "bookingType",
          opr: "==",
          value: bookingTypes.PRIVATE_YACHT.value,
        },
      ]),
    data: listenToPrivateYachtBookings,
    deps: [dispatch],
  });
  const handelAddBoard = () => {
    history("/booking/new-private-yacht-booking");
  };
  const handelRestFilter = () => {
    dispatch(listenToPrivateYachtBookingFilter({}, 0, 20));
  };
  return (
    <PageToolbar>
      <Button
        type="primary"
        onClick={handelAddBoard}
        block
        icon={<PlusOutlined />}
        className="page-toolbar-btn"
      >
        {width > 600 && "Add Private Yacht Booking"}
      </Button>

      <div className="page-toolbar-right-children-elements">
        <Input.Search
          placeholder="Search by booking ID"
          allowClear
          value={searchBookingId}
          onChange={(e) => onSearchBookingIdChange(e.target.value)}
          style={{ width: 220 }}
        />
        <Button
          type="link"
          onClick={handelRestFilter}
          icon={<FilterOutlined />}
          className="page-toolbar-btn-link"
        >
          {width > 600 && "Reset Filters"}
        </Button>
        <div className="total-amount"> € {privateYachtBookingTotal}</div>
      </div>
    </PageToolbar>
  );
};
